import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const DiffDaysIndicator = css`
  font-size: 12px;
  color: ${theme.colors.grays[1]};
  margin-top: 3px;
  display: block;
`;

export const ContainerStyle = css`
  .ant-picker {
    border-radius: 3px;
    border: ${theme.borders[0]} solid ${theme.colors.darkBlues[50]};
    padding: 0px 11px 0px 0px;
  }
  .ant-picker-disabled {
    background-color: ${theme.colors.darkBlues[10]};
    border: ${theme.borders[0]} solid ${theme.colors.darkBlues[50]};
    cursor: unset;
  }
  .ant-picker-input > input[disabled] {
    color: ${theme.colors.darkBlues[90]};
    cursor: unset;
  }
  .ant-picker-focused {
    border-color: ${theme.colors.blues[100]} !important;
    box-shadow: 0 0 4px 1px ${theme.colors.blues[50]} !important;
  }
  input {
    font-size: ${theme.fontSizes[2]};
    line-height: ${theme.lineHeights[3]};
    padding: ${theme.space[1]} 0;
    outline: 0;
    color: ${theme.colors.darkBlues[90]};
    box-sizing: border-box;
    -webkit-appearance: none;

    &::placeholder {
      opacity: 1;
      color: ${theme.colors.darkBlues[25]};
    }

    .ant-select-focused .ant-select-selector,
    .ant-select-selector:focus,
    .ant-select-selector:active,
    .ant-select-open .ant-select-selector {
      border-color: unset !important;
      box-shadow: none !important;
    }
  }
`;

export const InvalidStyle = css`
  .ant-picker {
    border-color: ${theme.colors.reds[100]} !important;
    box-shadow: 0 0 4px 1px ${theme.colors.reds[50]} !important;
    background-color: ${theme.colors.reds[10]};
  }
`;

export const CalendarIcon = css`
  color: ${theme.colors.darkBlues[75]};
`;
